<script>
import {api, GrantedCondition} from 'macarons'
import EventBus from './events'
import config from './config'

export default {
  data () {
    return {
      editing: false,
      width: 0,
      height: 0,
      id: null,
      editable: null,
      canEdit: null
    }
  },
  mounted () {
    this.setMenu()
  },
  beforeDestroy () {
    if (this.editing) {
      this.cancel()
    }
  },
  methods: {
    setMenu (more) {
      if (this.canEdit) {
        this.$emit('menuChange', (this.editing ? [
          {label: 'Sauvegarder', value: this.save},
          {label: 'Annuler', value: this.cancel}
        ] : [
          {label: 'Éditer', value: this.edit}
        ]).concat(more || []))
      } else if (this.canEdit === null) {
        const condition = new GrantedCondition('edit', config.widgetClass)
        condition.resolve().then(grant => {
          this.canEdit = grant
          if (this.canEdit) {
            this.setMenu()
          }
        })
      } else {
        this.$emit('menuChange', more)
      }
    },
    edit () {
      this.editing = true
      EventBus.$emit('graph:edit', this.editable, this)
    },
    cancel () {
      this.editing = false
      EventBus.$emit('graph:cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/Editable.vue